/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2} from "@mui/material";
import {useAvisos} from "../../Modulo_Avisos/Hooks/useAvisos";
import {useLoaders} from "../../Modulo_Loaders/Hooks/useLoaders";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {borrarRegistro} from "../../Modulo_Algolia/Funciones/borrarRegistro";
import Formulario_Pedido_Productos from "../Formularios/Formulario_Pedido_Productos";
import {obtenerValorPedido} from "../../Utilidades/obtenerValorPedido";
import Formulario_Pedido_Factura from "../Formularios/Formulario_Pedido_Factura";

const Dialogo_Pedido_Factura = ({datos, cerrar, realizado}) => {
    const {Avisos, nuevoAviso, terminar} = useAvisos({funcionUno: cerrar, funcionDos: realizado})
    const {Cargador, abrirCargador, setDetener} = useLoaders({logo: logo})
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})


    const subirDatos = async (datos) => {

        let entidad = await obtenerEntidad()

        abrirCargador('Guardando Datos')
        entidad.valor = obtenerValorPedido(entidad.productos)

        let dox = await guardarDoc('pedidos', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('productos', datos.id)
        terminar({aviso: 'Usuarios borrado'})
        await borrarRegistro({coleccion: 'productos', id: datos.id})
    }
    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Pedido_Factura props={props}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid2>

            {datos && datos.id &&
                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid2>
            }


        </Grid2>
    )

}
export default Dialogo_Pedido_Factura